module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Downloads-folder-6a3e2800fddc8f8bfe445391c3a0b5cf.svg";